import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { FixedTableModule } from 'Src/ng2/shared/components/list/fixed-table/fixed-table.module';
import { FixedToInfiniteViewModule } from 'Src/ng2/shared/components/list/fixed-to-infinite-view-container/fixed-to-infinite-view.module';
import { MadlibModule } from '../../../shared/components/list/mad-lib/mad-lib.module';
import { PageHeaderModule } from './../../../shared/components/header/page-header/page-header.module';
import { ListContainerModule } from './../../../shared/components/list/list-container/list-container.module';
import { Madlib } from './../../../shared/components/list/mad-lib/mad-lib.component';
import { SharedServicesModule } from './../../../shared/services/shared.services.module';
import { ContentToolsModule } from './../../../shell/content-tools/content-tools.module';
import { BatchActionsService } from './../services/batch-actions/batch-actions.service';
import { ListHeaderService } from './../services/list-headers/list-headers.service';
import { ListNavigationService } from './../services/list-navigation/list-navigation.service';
import { MadlibService } from './../services/madlib/madlib.service';
import { AcademicDataService } from './academic-list-data/academic-data.service';
import { AcademicListContainer } from './academic-list-v2.component';

@NgModule({
  declarations: [AcademicListContainer],
  imports: [
    MatMenuModule,
    CommonModule,
    ListContainerModule,
    FixedToInfiniteViewModule,
    FixedTableModule,
    ContentToolsModule,
    PageHeaderModule,
    SharedServicesModule,
    MadlibModule,
  ],
  exports: [AcademicListContainer, Madlib],
  providers: [AcademicDataService, BatchActionsService, MadlibService, ListNavigationService, ListHeaderService],
})
export class AcademicListV2Module {}
